import React from 'react'
import { Footer } from '../components/Footer'
import { Header } from '../components/Header'
import HeadMeta from '../components/HeadMeta'

const SitemapPage = () => {
  return (
    <div>
      <HeadMeta title="サイトマップ | 株式会社ベツダイ" description="サイトマップのページです。大分・福岡の新築・中古・賃貸・戸建て・マンション・リフォーム・リノベーションのことならベツダイにお任せください。" />
      <noscript>
        &lt;style&gt;body{'{'}visibility:visible{'}'}&lt;/style&gt;
      </noscript>
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header /> 
        </div>
        <div className="c-page-sub__breadcrumb">
          <div className="c-nav-breadcrumb">
            <ol>
              <li className="c-nav-breadcrumb__item"><a href="/">トップ</a></li>
              <li className="c-nav-breadcrumb__item" data-breadcrumb="current">サイトマップ</li>
            </ol>
          </div>
        </div>
        <div className="c-page-sub__main">
          <main>
            <article>
              <div className="c-page-sub__title-page">
                <div className="c-title-page" data-page="default">
                  <h1><span data-lang="en">SITEMAP</span><span data-lang="ja">サイトマップ</span></h1>
                </div>
              </div>
              <div className="c-page-sub__content-main">
                <div className="c-content-main">
                  <section data-type="section">
                    <div className="sitemap-contents">
                      <ul>
                        <li><a href="/">トップ</a></li>
                        <li><a href="/news">新着情報</a></li>
                        <li><a href="/event">イベント情報</a></li>
                        <li><a href="/afterservice">お客様サポート</a></li>
                        <li><a href="/company">企業情報</a></li>
                        <ul>
                          <li><a href="/company/about">会社概要</a></li>
                          <li><a href="/company/office">事務所・店舗案内</a></li>
                          <li><a href="/company/media">CM・メディア掲載</a></li>
                        </ul>
                        <li><a target="_blank" href="https://arwrk.net/recruit/hhc5p8u69gcdhd1">採用情報</a></li>
                        <ul>
                          <li><a target="_blank" href="https://arwrk.net/recruit/hhc5p8u69gcdhd1/#about">会社を知る</a></li>
                        </ul>
                        <li><a href="/oitanavi">おおいた移住キャンペーン</a></li>
                        <li><a href="https://betsudaihome.jp/zeh/" target="_blank">ZEH（ゼロエネルギー住宅）</a></li>
                        <li><a href="/contact">お問い合わせ</a></li>
                        <li><a href="/business">施工業者・ビジネスパートナー向けお問い合わせ</a></li>
                        <li><a href="/privacy">プライバシーポリシー</a></li>
                      </ul>
                      
                      <h6>サービス紹介</h6>
                      <dl>
                        <dt><span>- 家を、売る・買う</span></dt>
                        <dd>
                          <span>売る</span>
                          <ul>
                            <li><a href="/buy/#buy01">不動産売却</a></li>
                          </ul>
                          <span>買う</span>
                          <ul>
                            <li><a href="/buy/#buy02">新築戸建</a></li>
                            <li><a href="/buy/#buy03">土地</a></li>
                            <li><a href="/buy/#buy04">新築マンション</a></li>
                            <li><a href="/buy/#buy05">中古戸建・中古マンション</a></li>
                            <li><a href="/buy/#buy06">収益物件</a></li>
                            <li><a href="/buy/#buy07">リゾート物件</a></li>
                          </ul>
                        </dd>
                      </dl>

                      <dl>
                        <dt><span>- 家を、貸す・借りる</span></dt>
                        <dd>
                          <span data-level="02">貸す</span>
                          <ul data-level="02">
                            <li><a href="/rent/#rent01">賃貸管理</a></li>
                          </ul>
                          <span data-level="02">借りる</span>
                          <ul data-level="02">
                            <li><a href="/rent/#rent02">賃貸</a></li>
                          </ul>
                        </dd>
                      </dl>
                      

                      <dl>
                        <dt><span>- 家を、建てる・リフォーム</span></dt>
                        <dd>
                          <span data-level="02">建てる</span>
                          <ul data-level="02">
                            <li><a href="/build/#build01">新築戸建</a></li>
                            <li><a href="/build/#build01">規格・注文</a></li>
                            <li><a href="/build/#build02">リノベーション</a></li>
                          </ul>
                          <span data-level="02">リフォーム</span>
                          <ul data-level="02">
                            <li><a href="/build/#build03">リフォーム</a></li>
                          </ul>
                        </dd>
                      </dl>
                      
                      <dl>
                        <dt><span>- 家を、守る</span></dt>
                        <dd>
                          <span data-level="02">守る</span>
                          <ul data-level="02">
                            <li><a href="/afterservice/#afterservice01">お客さまサポート</a></li>
                            <li><a href="/afterservice/#afterservice02">マンション管理</a></li>
                          </ul>
                        </dd>
                      </dl>
                    </div>
                  </section>
                </div>
              </div>
            </article>
          </main>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default SitemapPage
